(function () {
    'use strict';

    angular.module('components.audit', [
        'components.api',
        'app.core',
        'smart-table',
        'ui.bootstrap'
    ]);
})();